"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const prop_types_1 = __importDefault(require("prop-types"));
/**
    Best with CMS Content Type => Epic Common Share Meta
*/
const MetaTags = ({ meta }) => {
    if (!meta)
        return null;
    const { title, description, image, keyWords } = meta;
    const tags = [];
    if (title) {
        tags.push({ itemProp: 'name', content: title }, { name: 'twitter:title', content: title }, { property: 'og:title', content: title });
    }
    if (description) {
        tags.push({ itemProp: 'description', content: description }, { name: 'description', content: description }, { name: 'twitter:description', content: description }, { property: 'og:description', content: description });
    }
    if (image) {
        tags.push({ name: 'twitter:image', content: image }, { property: 'og:image', content: image });
    }
    if (keyWords) {
        tags.push({ name: 'keywords', content: keyWords });
    }
    return react_1.default.createElement(react_helmet_1.default, { meta: tags }, title ? react_1.default.createElement("title", null, title) : null);
};
MetaTags.propTypes = {
    meta: prop_types_1.default.object
};
exports.default = MetaTags;
//# sourceMappingURL=MetaTags.js.map